// New-tell step indicator (DESIGN.md §5): three 18×4 bars; done steps in shoot, the rest in line.
// `dark` is for step 1, which is always dark.
export default function StepBars({step, dark = false}: {step: 1 | 2 | 3; dark?: boolean}) {
    return (
        <div aria-label={`Step ${step} of 3`} className="flex gap-1">
            {[1, 2, 3].map(n => (
                <span key={n} className={`h-1 w-[18px] rounded-[2px] ${n <= step ? (dark ? 'bg-[#7FCF76]' : 'bg-shoot') : dark ? 'bg-white/25' : 'bg-line'}`} />
            ))}
        </div>
    );
}
